import { Switch } from "@clockwise/design-system";
import { CalendarMode } from "@clockwise/web-commons/src/components/calendar";
import { TrackingEvents, useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import {
  useReadCalendar,
  useUpdateCalendar,
} from "@clockwise/web-commons/src/util/CalendarContext";
import classNames from "classnames";
import { isEmpty } from "lodash";
import React, { useMemo } from "react";
import { getEarliestDiffStart } from "../../chat/ai-chat/utils/getDiffStart";
import { useActiveDiffSummaries } from "../../chat/hooks/useActiveDiffSummary";

export const DayWeekViewToggle = () => {
  const track = useTracking();
  const { activeDiffSummaries } = useActiveDiffSummaries();
  const diffDate: string | null = useMemo(
    () =>
      activeDiffSummaries ? getEarliestDiffStart(activeDiffSummaries).toFormat("yyyy-MM-dd") : "",
    [activeDiffSummaries],
  );

  const calendarDispatch = useUpdateCalendar();
  const { focusedDate, visibleDates } = useReadCalendar();

  const isDay = visibleDates.length === 1;

  const handleCalendarModeChange = (mode: CalendarMode) => {
    const dateToFoucus = mode === "day" ? diffDate : focusedDate;
    if (mode === "day") {
      track(TrackingEvents.CALENDAR_SINGLE_DAY.TOGGLE_DAY);
    } else {
      track(TrackingEvents.CALENDAR_SINGLE_DAY.TOGGLE_WEEK);
    }

    calendarDispatch({
      type: "set-view",
      payload: { view: mode, date: dateToFoucus },
    });
  };

  const onToggle = () => {
    const newValue = !isDay;
    handleCalendarModeChange(newValue ? "day" : "week");
  };

  const Label = () => <div className="cw-body-sm">Day view</div>;
  if (isEmpty(activeDiffSummaries)) return null;
  return (
    <div
      className={classNames(
        "cw-mt-2 cw-px-3 cw-py-1.5 cw-absolute cw-bg-default cw-rounded-xl cw-left-[calc(50%-30px)] cw-drop-shadow-md",
        "cw-border-[0.5px] cw-border-solid cw-border-muted",
      )}
    >
      <Switch
        checked={isDay}
        onChange={onToggle}
        label={<Label />}
        labelPlacement="start"
        size="small"
      />
    </div>
  );
};
